import React from "react";
import { Box, Typography, Divider, useTheme } from "@mui/material";
import { useTranslation } from "react-i18next";
import FarmCard from "./FarmCard";

const FarmsListSection = ({
  farms,
  selectedFarm,
  handleCardClick,
  handleLocationIconClick,
}) => {
  const theme = useTheme();
  const { t } = useTranslation();

  return (
    <>
      <Box sx={{ mb: 2.5 }}>
        <Typography variant="h5" gutterBottom fontWeight="500">
          {t("Farms")}
        </Typography>
        <Divider />
      </Box>
      <Box
        sx={{
          flexGrow: 1,
          overflowY: "auto",
          pr: 1.5,
          mr: -1.5,
          "&::-webkit-scrollbar": {
            width: "10px",
          },
          "&::-webkit-scrollbar-track": {
            backgroundColor: "rgba(0,0,0,0.1)",
            borderRadius: "10px",
          },
          "&::-webkit-scrollbar-thumb": {
            backgroundColor: theme.palette.primary.light,
            borderRadius: "10px",
          },
        }}
      >
        {farms.map((farm) => (
          <FarmCard
            key={farm.id}
            farm={farm}
            selectedFarm={selectedFarm}
            handleCardClick={handleCardClick}
            handleLocationIconClick={handleLocationIconClick}
          />
        ))}
      </Box>
    </>
  );
};

export default FarmsListSection;
